export const AdminVI = {
    "system":"Hệ thống",
    "admin":"Admin",
    "userAccount":"Tài khoản người dùng",
    "department":"Phòng ban",
    "departmentAndBranch":"Phòng ban, chi nhánh",
    "business":"Khối nghiệp vụ",
    "userGroup":"Nhóm người dùng",
    "paymentAndStatement":"Thanh toán đối soát",
    "accountInformation":"Thông tin tài khoản",
    "currencyControl":"Quản lý tiền tệ",
    "ssoConfig":"Cấu hình SSO",

}